import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { ProfileMetadataLego } from '../../shared/dto/profile-metadata.lego';
import { EmailOptInMetaDataLego } from '../../shared/dto/email-optin-metadata.lego';

@Component({
  selector: 'wl-profile-lego-edit',
  templateUrl: './profile-lego-edit.component.html',
  styleUrls: ['./profile-lego-edit.component.less'],
  encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ProfileLegoEditComponent implements OnInit {
  @Input() profileData: ProfileMetadataLego;
  @Input() isOrg = false;

  constructor() {}

  ngOnInit(): void {
    this.profileData.EmailOptInMetaDataLego = {} as EmailOptInMetaDataLego;
  }
}
